import React, { useState } from 'react';

function Image({
  src,
  alt = "Image Name",
  className = "",
  ...props
}) {
  const [imgSrc, setImgSrc] = useState(src);
  const [hasError, setHasError] = useState(false);

  const handleError = () => {
    console.error(`Failed to load image: ${imgSrc}`);
    if (!hasError) {
      setImgSrc("/assets/images/no_image.png");
      setHasError(true);
    }
  };

  // Update imgSrc if prop src changes
  React.useEffect(() => {
    console.log(`Image src set to: ${src}`);
    setImgSrc(src);
    setHasError(false);
  }, [src]);

  return (
    <img
      src={imgSrc}
      alt={alt}
      className={className}
      onError={handleError}
      {...props}
    />
  );
}

export default Image;
